<template>
    <v-container v-resize="onResize">
        <template>
            <v-card v-if="loading">
                <v-container fluid>
                    <v-layout row wrap>
                        <v-flex xs12>
                            <div class="loader"></div>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card>
        </template>
        <div v-show="!loading">
            <v-layout row wrap>
                <v-flex sm12 md12 lg6 xl7>
                    <v-card v-if="data != null && data.Question" class="mt-0 pa-1">
                        <v-card-title>
                            <h2 class="title font-weight-bold" style="font-size: 1.75rem !important;">{{ data.Title }}</h2>
                        </v-card-title>
                        <v-card-text class="pt-0 pb-0">
                            <v-layout row wrap>
                                <v-flex xs12 md8 lg12 xl8 class="pr-md-4 pr-xl-5">
                                    <h3>Question:</h3>
                                    <div v-html="data.Question"></div>
                                    <h3 class="pb-2">
                                        Result: <v-icon aria-hidden="true" class="ml-1" :color="data.Carried ? 'green darken-2' : 'red darken-2'">
                                            {{ data.Carried ? 'check_circle' : 'cancel' }}
                                        </v-icon> {{ data.Carried ? 'Carried' : 'Not carried' }} 
                                        <br v-if="this.isMobile && data.VoteMajority != 0 && data.StateMajority != 0" /> 
                                        <span class="pl-3 pl-xs-0 font-weight-regular" v-if="data.VoteMajority != 0 && data.StateMajority != 0">States voting yes: {{data.StateMajority}}</span>
                                        <br v-if="this.isMobile && data.VoteMajority != 0" /> 
                                        <span class="pl-3 pl-xs-0 font-weight-regular" v-if="data.VoteMajority != 0">Total yes votes: {{data.VoteMajority}}%</span>
                                        <br v-if="this.isMobile && data.MostPopularOption != null" /> 
                                        <span class="pl-3 pl-xs-0 " v-if="data.MostPopularOption != null">Most popular option: {{data.MostPopularOption}} ({{data.MostPopularOptionPercentage}})%</span>
                                    </h3>
                                    <h3 v-if="data.ReferendumType === 'National Survey'">Date opened: {{ data.Date | stringDateFormat }}</h3>
                                    <h3 v-else>Date: {{ data.Date | stringDateFormat }}</h3>
                                    <h3 v-if="data.DateClosed">Date closed: {{ data.DateClosed | stringDateFormat }}</h3>
                                    <h3 v-if="data.DateResultAnnounced">Date result announced: {{ data.DateResultAnnounced | stringDateFormat }}</h3>
                                </v-flex>
                                <v-flex xs12 md4 lg12 xl4 class="pr-2 pl-xl-0 pt-0">
                                    <br />
                                    <v-layout row wrap>
                                        <v-flex sm6 md6 lg6>
                                            <Portrait v-bind:PHID="data.PrimeMinister.Phid" :fixedWidth="80"></Portrait>
                                            <h4>Prime Minister:<br />{{data.PrimeMinister.DisplayName}}</h4>
                                            <h5>{{data.PrimeMinister.Party}}</h5>
                                            <br />
                                        </v-flex>
                                        <v-flex sm6 md6 lg6>
                                            <Portrait v-bind:PHID="data.LeaderOfOpposition.Phid" :fixedWidth="80"></Portrait>
                                            <h4>Leader of the Opposition:<br />{{data.LeaderOfOpposition.DisplayName}}</h4>
                                            <h5>{{data.LeaderOfOpposition.Party}}</h5>
                                            <br />
                                        </v-flex>
                                    </v-layout>
                                    

                                </v-flex>
                            </v-layout>
                            <v-flex sm12 class="fill-height hidden-print-only">
                                <div class="pb-2" v-if="data != null && data.ReferendumType == 'Referendum'">
                                    <v-btn v-if="data.IntroducedLink != null" :color="data.IntroducedLink.indexOf('hansardr') > -1 ? 'green darken-3' : 'red darken-4'" class="ml-0" style="text-transform: none; border-radius: 5px;" :href="data.IntroducedLink" target="_blank">
                                        <span style="color: white" v-if="data.IntroducedLink.indexOf('hansardr') > -1">
                                            {{ data.IntroducedLinkText == null ? 'First introduced in House' : data.IntroducedLinkText }}
                                        </span>
                                        <span style="color: white" v-if="data.IntroducedLink.indexOf('hansards') > -1">
                                            {{ data.IntroducedLinkText == null ? 'First introduced in Senate' : data.IntroducedLinkText }}
                                        </span>
                                    </v-btn>

                                    <template v-if="data.IntroducedLink != null && data.IntroducedLink.indexOf('hansardr') > -1">
                                        <v-btn v-if="data.HouseVoteLink != null" :color="data.HouseVoteLink.indexOf('votes') > -1 ? 'green darken-3' : 'red darken-4'" style="text-transform: none; border-radius: 5px;" :href="data.HouseVoteLink" target="_blank">
                                            <span style="color: white">
                                                {{ data.HouseVoteLinkText == null ? 'Third reading vote in House' : data.HouseVoteLinkText }}
                                            </span>
                                        </v-btn>

                                        <v-btn v-if="data.SenateVoteLink != null" :color="data.SenateVoteLink.indexOf('journals') > -1 ? 'red darken-4' : 'green darken-3' " style="text-transform: none; border-radius: 5px;" :href="data.SenateVoteLink" target="_blank">
                                            <span style="color: white">
                                                {{ data.SenateVoteLinkText == null ? 'Third reading vote in Senate' : data.SenateVoteLinkText }}
                                            </span>
                                        </v-btn>
                                    </template>
                                    <template v-else>
                                        <v-btn v-if="data.IntroducedLink != null && data.SenateVoteLink != null" :color="data.SenateVoteLink.indexOf('journals') > -1 ? 'red darken-4' : 'green darken-3' " style="text-transform: none; border-radius: 5px;" :href="data.SenateVoteLink" target="_blank">
                                            <span style="color: white">
                                                {{ data.SenateVoteLinkText == null ? 'Third reading vote in Senate' : data.SenateVoteLinkText }}
                                            </span>
                                        </v-btn>
                                        
                                        <v-btn v-if="data.IntroducedLink != null && data.HouseVoteLink != null" :color="data.HouseVoteLink.indexOf('votes') > -1 ? 'green darken-3' : 'red darken-4'" style="text-transform: none; border-radius: 5px;" :href="data.HouseVoteLink" target="_blank">
                                            <span style="color: white">
                                                {{ data.HouseVoteLinkText == null ? 'Third reading vote in House' : data.HouseVoteLinkText }}
                                            </span>
                                        </v-btn>
                                    </template>

                                    <v-btn v-if="data.BillLink != null" color="primary" style="text-transform: none; border-radius: 5px;" :href="data.BillLink" target="_blank">
                                        <span>
                                            {{ data.BillLinkText == null ? 'Bill' : data.BillLinkText }}
                                        </span>
                                    </v-btn>
                                </div>
                                <div v-if="data.Notes != null" v-html="data.Notes"></div>
                            </v-flex>
                        </v-card-text>
                    </v-card>
                </v-flex>
                <v-flex sm12 md12 lg6 xl5  class="fill-height">
                    <v-layout row wrap class="ml-md-0 ml-lg-4 ml-xl-4 mt-xs-4 mt-md-4">
                        <v-flex sm12 md6 lg12 xl4>
                            <v-card v-if="data != null && data.Question" class="mt-0 pa-1 ">
                                <v-card-title class="mb-1" style="max-height: 52px;">
                                    <span class="font-weight-bold" style="font-size:1rem;">
                                        <v-icon aria-hidden="true" class="mr-1">help</v-icon>
                                        Information
                                    </span>
                                </v-card-title>
                                <v-card-text class="pt-0 pb-0">
                                    <p v-if="this.data.ReferendumType === 'Referendum'">The Constitution originally provided that Bills to alter the Constitution had to be approved
                                        by referendum in a majority of States and by a majority of all electors voting.<br /><br />Following
                                        an amendment in 1977, the Constitution now allows electors in the Territories, as well as
                                        electors in the States, to vote in constitutional referendums. Territory votes are included
                                        in the national total only.</p>
                                    <p v-if="this.data.ReferendumType === 'Plebiscite'">A plebiscite is a national vote on a matter that does not change the Constitution. Unlike referendums, plebiscites have no established statutory framework to establish or direct them.</p>
                                    <p v-if="this.data.ReferendumType === 'National Survey'">Like a plebiscite, national surveys do not change the Constitution and have no statutory framework to establish or direct them.</p>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                        <v-flex sm12 md6 lg12 xl8 class="pl-3">
                            <div v-if="data != null && data.Results != null && data.Results != undefined" >
                                <AustralianStates :resultsArray="data.Results" />
                            </div>
                        </v-flex>
                    </v-layout>

                    <v-menu v-if="this.isMobile" d-inline offset-y :nudge-left="140" style="float:right" :close-on-content-click="true">
                        <v-btn outline small slot="activator">
                            Sort <v-icon>sort</v-icon>
                        </v-btn>
                        <v-list>
                             <v-subheader
                                >
                                Sort by:
                                </v-subheader>
                            <v-list-tile v-for="(item, index) in headersExtra.filter(h => h.text != '' && h.sortable != false)" :key="item.value" @click="changeSort(item.value)">
                                <v-list-tile-title>
                                    {{ item.text }}
                                    <v-icon v-if="PAGINATION.sortBy === item.value">{{PAGINATION.descending ? 'arrow_downward':'arrow_upward'}}</v-icon>
                                </v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </v-flex>
            </v-layout>
            <br/>
            <loader v-if="loading" /> 
            <div class="page-break"></div>
            <v-data-table 
                v-if="!loading"
                :headers="headersExtra"            
                :pagination.sync="PAGINATION"
                :hide-headers="isMobile || isPrint"
                :disable-initial-sort="true"
                :class="{ mobileDataTable: isMobile || isPrint, 'elevation-1': true, 'multi-referendum': data.Options.length > 0 }"
                :hide-actions="true"
                :items="data.Results">

                <!-- Plebiscite with options, e.g. national song -->
                <template v-slot:items="props" v-if="data.Options.length > 0">
                    <tr v-if="props.item.StateAbbrev && props.item.StateAbbrev !== 'default'" >
                        <template v-if="isMobile">
                            <td>
                                <div class="flex-content">
                                    <div class="flex-item"><h3 class="pt-2 pb-xs-0">{{ props.item.State }}</h3></div>
                                    <template v-for="option in data.Options">
                                        <div class="flex-item" :data-label="option" :key="option + props.item.State">
                                            {{ (props.item.OptionVotes.findIndex(o => o.Option === option) !== -1 ? 
                                            props.item.OptionVotes.find(o => o.Option === option).VotesPercentage : 0) }}%
                                            ({{ (props.item.OptionVotes.findIndex(o => o.Option === option) !== -1 ?
                                                props.item.OptionVotes.find(o => o.Option === option).Votes  : 0 ) | commas }})
                                        </div>
                                    </template>
                                    <div class="flex-item px-2"><v-divider></v-divider></div>
                                    <div class="flex-item flex-item-col flex-item-col-40" data-label="Votes">{{ props.item.VotesPercentage }}% ({{ props.item.Votes | commas }})</div>
                                    <div class="flex-item flex-item-col flex-item-col-30" data-label="Enrolled">{{ props.item.Enrolled | commas }}</div>
                                    <div class="flex-item flex-item-col flex-item-col-30" data-label="Informal">{{ props.item.InformalPercentage }}% ({{ props.item.InformalVotes | commas }})</div>
                                </div>
                            </td>
                        </template>
                        <template v-else-if="isPrint">
                            <td>
                                <div class="flex-content">
                                    <div class="flex-item"><h3 class="pt-2 pb-xs-0">{{ props.item.State }}</h3></div>
                                    <template v-for="option in data.Options">
                                        <div class="flex-item flex-item-col flex-item-col-25" :data-label="option" :key="option + props.item.State">
                                            {{ (props.item.OptionVotes.findIndex(o => o.Option === option) !== -1 ? 
                                            props.item.OptionVotes.find(o => o.Option === option).VotesPercentage : 0) }}%
                                            ({{ (props.item.OptionVotes.findIndex(o => o.Option === option) !== -1 ?
                                                props.item.OptionVotes.find(o => o.Option === option).Votes  : 0 ) | commas }})
                                        </div>
                                    </template>
                                    <div class="flex-item px-2"><v-divider></v-divider></div>
                                    <div class="flex-item flex-item-col flex-item-col-25" data-label="Votes">{{ props.item.VotesPercentage }}% ({{ props.item.Votes | commas }})</div>
                                    <div class="flex-item flex-item-col flex-item-col-25" data-label="Enrolled">{{ props.item.Enrolled | commas }}</div>
                                    <div class="flex-item flex-item-col flex-item-col-25" data-label="Informal">{{ props.item.InformalPercentage }}% ({{ props.item.InformalVotes | commas }})</div>
                                </div>
                            </td>
                        </template>
                        <template v-else>
                            <td class="text-xs-left">{{ props.item.State }}</td>
                            <template v-for="option in data.Options">
                                <td class="text-xs-left"  :key="option + props.item.State">
                                    {{ (props.item.OptionVotes.findIndex(o => o.Option === option) !== -1 ? 
                                    props.item.OptionVotes.find(o => o.Option === option).VotesPercentage : 0) }}%
                                    ({{ (props.item.OptionVotes.findIndex(o => o.Option === option) !== -1 ?
                                        props.item.OptionVotes.find(o => o.Option === option).Votes  : 0 ) | commas }})
                                </td>
                            </template>
                            <td class="text-xs-left" style="border-left: 1px solid #d9d9d9;">{{ props.item.Enrolled | commas }}</td>
                            <td class="text-xs-left">{{ props.item.VotesPercentage }}% ({{ props.item.Votes | commas }})</td>
                            <td class="text-xs-left">{{ props.item.InformalPercentage }}% ({{ props.item.InformalVotes | commas }})</td>
                        </template>
                    </tr>
                </template>
                <!-- Yes/No referendums and plebiscites -->
                <template v-slot:items="props" v-else>
                    <router-link class="tr" v-if="props.item.StateAbbrev && props.item.StateAbbrev !== 'default'" 
                    :to="{ name: 'ReferendumDivision', params: { state: props.item.StateAbbrev }}">
                        <template v-if="isMobile">
                            <td>
                                <div class="flex-content">
                                    <div class="flex-item"><h3 class="pt-2 pb-xs-0">{{ props.item.State }}</h3></div>
                                    <div class="flex-item flex-item-col  flex-item-col-40" data-label="For">{{ props.item.ForPercentage }}% ({{ props.item.ForVotes | commas }})</div>
                                    <div class="flex-item flex-item-col flex-item-col-60 " data-label="Against">{{ props.item.AgainstPercentage }}% ({{ props.item.AgainstVotes | commas }})</div>
                                    <div class="flex-item px-2"><v-divider></v-divider></div>
                                    <div class="flex-item flex-item-col flex-item-col-40" data-label="Votes">{{ props.item.VotesPercentage }}% ({{ props.item.Votes | commas }})</div>
                                    <div class="flex-item flex-item-col flex-item-col-30" data-label="Enrolled">{{ props.item.Enrolled | commas }}</div>
                                    <div class="flex-item flex-item-col flex-item-col-30" data-label="Informal">{{ props.item.InformalPercentage }}% ({{ props.item.InformalVotes | commas }})</div>
                                </div>
                            </td>
                        </template>
                        <template v-else-if="isPrint">
                            <td>
                                <div class="flex-content">
                                    <div class="flex-item"><h3 class="pt-2 pb-xs-0">{{ props.item.State }}</h3></div>
                                    <div class="flex-item flex-item-col  flex-item-col-20" data-label="For">{{ props.item.ForPercentage }}% ({{ props.item.ForVotes | commas }})</div>
                                    <div class="flex-item flex-item-col flex-item-col-20 " data-label="Against">{{ props.item.AgainstPercentage }}% ({{ props.item.AgainstVotes | commas }})</div>
                                    <div class="flex-item flex-item-col flex-item-col-20" data-label="Votes">{{ props.item.VotesPercentage }}% ({{ props.item.Votes | commas }})</div>
                                    <div class="flex-item flex-item-col flex-item-col-20" data-label="Enrolled">{{ props.item.Enrolled | commas }}</div>
                                    <div class="flex-item flex-item-col flex-item-col-20" data-label="Informal">{{ props.item.InformalPercentage }}% ({{ props.item.InformalVotes | commas }})</div>
                                </div>
                            </td>
                        </template>
                        <template v-else>
                            <td class="text-xs-left">
                                {{ props.item.State }}
                            </td>
                            <td class="text-xs-left">{{ props.item.ForPercentage }}% </td>
                            <td class="text-xs-left">{{ props.item.ForVotes | commas }}</td>
                            <td class="text-xs-left">{{ props.item.AgainstPercentage }}%</td>
                            <td class="text-xs-left">{{ props.item.AgainstVotes | commas }}</td>
                            <td class="text-xs-left" style="border-left: 1px solid #d9d9d9;">{{ props.item.Enrolled | commas }}</td>
                            <td class="text-xs-left">{{ props.item.VotesPercentage }}% ({{ props.item.Votes | commas }})</td>
                            <td class="text-xs-left">{{ props.item.InformalPercentage }}% ({{ props.item.InformalVotes | commas }})</td>
                        </template>
                    </router-link>
                </template>
                <template v-slot:footer>
                    <template v-if="data.Options.length > 0">
                        <template v-if="isMobile">
                            <td>
                                <div class="flex-content">
                                    <div class="flex-item"><h3 class="pt-2 pb-xs-0">{{ totalRow.State }}</h3></div>
                                    <template v-for="option in data.Options">
                                        <div class="flex-item" :data-label="option" :key="option + totalRow.State">
                                            {{ (totalRow.OptionVotes.findIndex(o => o.Option === option) !== -1 ? 
                                            totalRow.OptionVotes.find(o => o.Option === option).VotesPercentage : 0) }}%
                                            ({{ (totalRow.OptionVotes.findIndex(o => o.Option === option) !== -1 ?
                                                totalRow.OptionVotes.find(o => o.Option === option).Votes  : 0 ) | commas }})
                                        </div>
                                    </template>
                                    <div class="flex-item px-2"><v-divider></v-divider></div>
                                    <div class="flex-item flex-item-col flex-item-col-40" data-label="Votes">{{ totalRow.VotesPercentage }}% ({{ totalRow.Votes | commas }})</div>
                                    <div class="flex-item flex-item-col flex-item-col-30" data-label="Enrolled">{{ totalRow.Enrolled | commas }}</div>
                                    <div class="flex-item flex-item-col flex-item-col-30" data-label="Informal">{{ totalRow.InformalPercentage }}% ({{ totalRow.InformalVotes | commas }})</div>
                                </div>
                            </td>
                        </template>
                        <template v-else-if="isPrint">
                            <td>
                                <div class="flex-content">
                                    <div class="flex-item"><h3 class="pt-2 pb-xs-0">{{ totalRow.State }}</h3></div>
                                    <template v-for="option in data.Options">
                                        <div class="flex-item flex-item-col flex-item-col-25" :data-label="option" :key="option + totalRow.State">
                                            {{ (totalRow.OptionVotes.findIndex(o => o.Option === option) !== -1 ? 
                                            totalRow.OptionVotes.find(o => o.Option === option).VotesPercentage : 0) }}%
                                            ({{ (totalRow.OptionVotes.findIndex(o => o.Option === option) !== -1 ?
                                                totalRow.OptionVotes.find(o => o.Option === option).Votes  : 0 ) | commas }})
                                        </div>
                                    </template>
                                    <div class="flex-item px-2"><v-divider></v-divider></div>
                                    <div class="flex-item flex-item-col flex-item-col-25" data-label="Votes">{{ totalRow.VotesPercentage }}% ({{ totalRow.Votes | commas }})</div>
                                    <div class="flex-item flex-item-col flex-item-col-25" data-label="Enrolled">{{ totalRow.Enrolled | commas }}</div>
                                    <div class="flex-item flex-item-col flex-item-col-25" data-label="Informal">{{ totalRow.InformalPercentage }}% ({{ totalRow.InformalVotes | commas }})</div>
                                </div>
                            </td>
                        </template>
                        <template v-else>
                            <td class="text-xs-left font-weight-bold">{{ totalRow.State }}</td>
                            <template v-for="option in data.Options">
                                <td class="text-xs-left font-weight-bold" :data-label="option" :key="option + totalRow.State">
                                    {{ (totalRow.OptionVotes.findIndex(o => o.Option === option) !== -1 ? 
                                    totalRow.OptionVotes.find(o => o.Option === option).VotesPercentage : 0) }}%
                                    ({{ (totalRow.OptionVotes.findIndex(o => o.Option === option) !== -1 ?
                                        totalRow.OptionVotes.find(o => o.Option === option).Votes  : 0 ) | commas }})
                                </td>
                            </template>
                            <td class="text-xs-left font-weight-bold" style="border-left: 1px solid #d9d9d9;">{{ totalRow.Enrolled | commas }}</td>
                            <td class="text-xs-left font-weight-bold">{{ totalRow.VotesPercentage }}% ({{ totalRow.Votes | commas }})</td>
                            <td class="text-xs-left font-weight-bold">{{ totalRow.InformalPercentage }}% ({{ totalRow.InformalVotes | commas }})</td>
                        </template>
                    </template>
                    <template v-else>
                        <template v-if="isMobile">
                            <td>
                                <div class="flex-content">
                                    <div class="flex-item"><h3 class="pb-xs-0 pt-2 ">{{ totalRow.State }}</h3></div>
                                    <div class="flex-item flex-item-col  flex-item-col-40" data-label="For">{{ totalRow.ForPercentage }}% ({{ totalRow.ForVotes | commas }})</div>
                                    <div class="flex-item flex-item-col flex-item-col-60 " data-label="Against">{{ totalRow.AgainstPercentage }}% ({{ totalRow.AgainstVotes | commas }})</div>
                                    <div class="flex-item px-2"><v-divider></v-divider></div>
                                    <div class="flex-item flex-item-col flex-item-col-40" data-label="Votes">{{ totalRow.VotesPercentage }}% ({{ totalRow.Votes | commas }})</div>
                                    <div class="flex-item flex-item-col flex-item-col-30" data-label="Enrolled">{{ totalRow.Enrolled | commas }}</div>
                                    <div class="flex-item flex-item-col flex-item-col-30" data-label="Informal">{{ totalRow.InformalPercentage }}% ({{ totalRow.InformalVotes | commas }})</div>
                                </div>
                            </td>
                        </template>
                        <template v-else-if="isPrint">
                            <td>
                                <div class="flex-content">
                                    <div class="flex-item"><h3 class="pb-xs-0 pt-2">{{ totalRow.State }}</h3></div>
                                    <div class="flex-item flex-item-col  flex-item-col-20" data-label="For">{{ totalRow.ForPercentage }}% ({{ totalRow.ForVotes | commas }})</div>
                                    <div class="flex-item flex-item-col flex-item-col-20" data-label="Against">{{ totalRow.AgainstPercentage }}% ({{ totalRow.AgainstVotes | commas }})</div>
                                    <div class="flex-item flex-item-col flex-item-col-20" data-label="Votes">{{ totalRow.VotesPercentage }}% ({{ totalRow.Votes | commas }})</div>
                                    <div class="flex-item flex-item-col flex-item-col-20" data-label="Enrolled">{{ totalRow.Enrolled | commas }}</div>
                                    <div class="flex-item flex-item-col flex-item-col-20" data-label="Informal">{{ totalRow.InformalPercentage }}% ({{ totalRow.InformalVotes | commas }})</div>
                                </div>
                            </td>
                        </template>
                        <template v-else>
                            <td class="text-xs-left font-weight-bold">{{ totalRow.State }}</td>
                            <td class="text-xs-left font-weight-bold">{{ totalRow.ForPercentage }}%</td>
                            <td class="text-xs-left font-weight-bold">{{ totalRow.ForVotes | commas }}</td>
                            <td class="text-xs-left font-weight-bold">{{ totalRow.AgainstPercentage }}%</td>
                            <td class="text-xs-left font-weight-bold">{{ totalRow.AgainstVotes | commas }}</td>
                            <td class="text-xs-left font-weight-bold" style="border-left: 1px solid #d9d9d9;">{{ totalRow.Enrolled | commas }}</td>
                            <td class="text-xs-left font-weight-bold">{{ totalRow.VotesPercentage }}% ({{ totalRow.Votes | commas }})</td>
                            <td class="text-xs-left font-weight-bold">{{ totalRow.InformalPercentage }}% ({{ totalRow.InformalVotes | commas }})</td>
                        </template>
                    </template>
                </template>
            </v-data-table>
            <br/>
            <v-layout row wrap class="hidden-print-only">
                <v-flex xs12>
                    <v-btn class="csvButton" @click="exportCsv" v-on:keyup.enter="exportCsv" color="primary">
                        <v-icon aria-hidden="true" :class="csvDownloadClass">{{csvDownloadIcon}}</v-icon>
                        <span>&nbsp;Download CSV</span>
                    </v-btn>
                </v-flex>
            </v-layout>
        </div>
    </v-container>
   
</template>

<script>
import print from '../../mixins/print';
import Loader from '@/components/Loader.vue';
import axios from 'axios';
window.Handbook = window.Handbook || {}
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;
import AustralianStates from "./AustralianStates.vue";
import Portrait from '@/components/Portrait.vue'

export default {
    props: ['id'],
    mixins: [print],
    components: {
        Loader,
        AustralianStates,
        Portrait
    },
    created() {
        this.initialiseData();
    },
    mounted() {
        this.onResize();
    },
    data() {
        return {
            isMobile: false,
            data: null,
            totalRow: null,
            csvDownloading: false,
            loading: true,
            PAGINATION: {
                rowsPerPage: 999,
                sortBy: '',
                descending: true
            },
            headers: [{
                text: 'State',
                value: 'State'
            },
            ]
        }
    },
    computed: {
        headersExtra: function() {
            // add options 
            var headers = [...this.headers];

            if (this.data != null && this.data.Options.length > 0) {
                this.data.Options.forEach(o => {
                    headers.push(({ text: o, value: o, sortable: false }))
                });
                headers.push(
                    {
                        text: 'Enrolled',
                        align: 'left',
                        value: 'Enrolled'
                    },
                    {
                        text: 'Votes (%)',
                        align: 'left',
                        value: 'VotesPercentage'
                    },{
                        text: 'Informal (%)',
                        align: 'left',
                        value: 'InformalPercentage'
                    });
                } else {
                    headers = [...headers, 
                    {
                        text: 'For (%)',
                        align: 'left',
                        value: 'ForPercentage'
                    },
                    {
                        text: 'For (votes)',
                        align: 'left',
                        value: 'ForVotes'
                    },
                    {
                        text: 'Against (%)',
                        align: 'left',
                        value: 'AgainstPercentage'
                    },
                    {
                        text: 'Against (votes)',
                        align: 'left',
                        value: 'AgainstVotes'
                    },
                    {
                        text: 'Enrolled',
                        align: 'left',
                        value: 'Enrolled'
                    },
                    {
                        text: 'Votes (%)',
                        align: 'left',
                        value: 'VotesPercentage'
                    },
                    {
                        text: 'Informal (%)',
                        align: 'left',
                        value: 'InformalPercentage'
                    }
                ];
            }
            return headers;
        },
        csvDownloadIcon(){
            return this.csvDownloading ? 'cached' : 'text_snippet';
        },
        csvDownloadClass(){
            let csvClass = 'mr-1';
            if (this.csvDownloading){
                csvClass = csvClass + ' loading'
            }
            return csvClass;
        }
    },
    methods: {
        onResize() {
            if (window.innerWidth < 1069){
                this.isMobile = true;
            }
            else{
                this.isMobile = false;
            }
        },
        changeSort(column) {
            if (this.PAGINATION.sortBy === column) {
                this.PAGINATION.descending = !this.PAGINATION.descending
            } 
            else {
                this.PAGINATION.sortBy = column
                this.PAGINATION.descending = false
            }
        },
        initialiseData: function () {
            this.loading = true;
            const url = `Referendums/Referendum/${this.id}`;
            axios.get(`api/${url}`)
                .then(response => {
                    this.data = response.data;
                    this.data.Results = this.data.Results.map(record => (
                        { ...record, 
                            Colour: record.ForPercentage >= 50 ? "rgb(0 128 0)" : "rgb(213 19 19)",
                            TooltipText: "<p>" + record.State + " - " + record.ForPercentage + "</p>"
                        }));

                    this.totalRow = this.data.Results.find(r => r.State.toLowerCase().indexOf('total') > -1);
                   
                    if (this.data != null){
                        window.document.title = this.data.Title;   
                        this.loading = false;
                    }

                    if (this.data.Options.length > 0){
                        var mostPopularOption = this.totalRow.OptionVotes.sort((c, d) => (c.VotesPercentage < d.VotesPercentage) ? 1 : -1)[0];
                        this.data.MostPopularOption = mostPopularOption.Option;
                        this.data.MostPopularOptionPercentage = mostPopularOption.VotesPercentage;
                    }
                });
        },
        exportCsv() {
            this.$gtag.event('referendum download csv', {
                'event_category': 'downloads',
                'event_label': `referendum csv download`,
                'value': 1
            });
            
            this.csvDownloading = true;
            let headers = ['State'];
            let filename = this.data.Title + " - (" + this.data.ReferendumType + ") state results";

            if (this.data.Options != null && this.data.Options.length > 0){
                this.data.Options.forEach(o => {
                    headers.push(o);
                });

                headers.push('Enrolled');
                headers.push('Total votes');
                headers.push('Informal votes');

                var records = this.data.Results.map(r => ({
                    'State': r.State,
                    'Total votes': r.Votes,
                    'Informal votes': r.InformalVotes,
                    'Options' : r.OptionVotes
                }));

                records.forEach(r => {
                    r.Options.forEach(o => {
                        r[o.Option.toString()]= o.Votes
                    })
                    r.Options = null;
                    delete r.Options;
                })


                this.$store.dispatch('GETCSV', { DATA: records, HEADERS: headers, FILENAME: filename })
                    .catch(this.showError)
                    .finally(() => this.csvDownloading = false);
            }
            else {
                let records = this.data.Results.map(r => ({
                    'State': r.State,
                    'For votes': r.ForVotes,
                    'Against votes': r.AgainstVotes,
                    'Enrolled': r.Enrolled,
                    'Total votes': r.Votes,
                    'Informal votes': r.InformalVotes
                }));

                this.$store.dispatch('GETCSV', { DATA: records, HEADERS: headers, FILENAME: filename })
                    .catch(this.showError)
                    .finally(() => this.csvDownloading = false);
            }
        }
    }
}
</script>
<style>
@media only print {
    .multi-referendum * {
        font-size: 10px !important;
    }
    .multi-referendum h3 {
        padding-top: 0 !important;
    }
}
</style>
